import color from "constants/color";
import styled from "styled-components";

export const ProductsContainer = styled.div`
  width: 100%;
  padding: 32px;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: 273px;
  margin-top: 104px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 8px;
`;

export const BtnEV = styled.button`
  width: 100%;
  height: 50px;
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: ${color.White};
  text-transform: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-top: 12px;

  &:hover {
    background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
    opacity: 0.8;
    cursor: pointer;
  }

  .link-icon {
    margin-left: 8px;
  }
`;

export const BtnStand = styled.button`
  width: 100%;
  height: 50px;
  background: #2d5bff;
  border-radius: 8px;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 14px;
  letter-spacing: -0.01em;
  color: ${color.White};
  text-transform: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin-top: 12px;

  &:hover {
    background: #2d5bff;
    opacity: 0.8;
    cursor: pointer;
  }
`;

interface Props {
  urlFoto: string;
}

export const HeaderTop = styled.div`
  width: 100%;
  padding: 16px;
  height: 50%;
  display: inline-flex;
  justify-content: space-between;
  border-radius: 8px 8px 0px 0px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${(props: Props) => `url(${props.urlFoto})`};
`;

export const HeaderBottom = styled.div`
  width: 100%;
  height: 50%;
  padding: 32px;
  display: inline-flex;
  border-radius: 0px 0px 8px 8px;
`;

export const CicleBandeira = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #ffffff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;

export const StatusTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d5bff;
  border-radius: 16px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  text-align: center;
  color: #ffffff;
  width: 109px;
  height: 24px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;

export const GridHeaderBottomLeft = styled.div`
  width: 50%;
`;

export const GridHeaderBottomRight = styled.div``;

export const TitleHeader = styled.h1`
  font-family: "Inter";
  font-size: 24px;
  font-weight: 400;
  line-height: 29px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #333333;
`;

export const SubtitleHeader = styled.a`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;

  color: #2d5bff;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 67px;
`;

export const TextItem = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: ${color.black};
  margin-top: 10px;
  max-width: 50px;
`;
